/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ws (ignored)
// module id = 42
// module chunks = 0